import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import type { Brand } from '../../types';

interface BrandSelectorProps {
  brands: Brand[];
  selectedBrandIds: string[];
  onBrandSelect: (brandIds: string[]) => void;
  className?: string;
  singleSelection?: boolean;
}

export const BrandSelector: React.FC<BrandSelectorProps> = ({
  brands,
  selectedBrandIds,
  onBrandSelect,
  className = '',
  singleSelection = false
}) => {
  const { t } = useTranslation();

  const handleBrandClick = (brandId: string) => {
    if (singleSelection) {
      onBrandSelect([brandId]);
    } else {
      if (selectedBrandIds.includes(brandId)) {
        onBrandSelect(selectedBrandIds.filter(id => id !== brandId));
      } else {
        onBrandSelect([...selectedBrandIds, brandId]);
      }
    }
  };

  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {t('teamMembers.selectBrand')}
      </label>
      <div className="grid grid-cols-2 gap-3">
        {brands.map(brand => (
          <button
            key={brand.id}
            onClick={() => handleBrandClick(brand.id)}
            className={`flex items-center gap-2 p-3 rounded-lg border relative ${
              selectedBrandIds.includes(brand.id)
                ? 'border-primary-600 bg-primary-50'
                : 'border-gray-200 hover:border-primary-600'
            }`}
          >
            <img 
              src={brand.logo} 
              alt={brand.name} 
              className="w-6 h-6 rounded-full"
            />
            <span className="text-sm text-gray-700">{brand.name}</span>
            {selectedBrandIds.includes(brand.id) && (
              <div className="absolute top-1 right-1 w-4 h-4 bg-primary-600 rounded-full flex items-center justify-center">
                <Check className="w-3 h-3 text-white" />
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};